import { Typography, Checkbox, FormControlLabel, Box } from "@mui/material";
import ConfirmationPopup from "components/common/ConfirmationPopup";
import React, { useState, useEffect } from "react";
import { useCelleraTheme } from "theme/useCelleraTheme";

export interface CancelPrescriptionModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  isLoading?: boolean;
}

export const CancelPrescriptionModal: React.FC<
  CancelPrescriptionModalProps
> = ({ open, onClose, onConfirm, isLoading = false }) => {
  const { colors } = useCelleraTheme();
  const [isUnderstood, setIsUnderstood] = useState(false);

  useEffect(() => {
    if (!open) {
      setIsUnderstood(false);
    }
  }, [open]);

  const handleConfirm = async () => {
    if (isUnderstood && !isLoading) {
      await onConfirm();
    }
  };

  return (
    <ConfirmationPopup
      open={open}
      onClose={onClose}
      onConfirm={handleConfirm}
      title="Cancel Prescription"
      message={
        <Box>
          <Typography
            variant="body1"
            sx={{
              color: colors.text.primary,
              fontSize: "18px",
              lineHeight: 1.5,
              mb: 2,
            }}
          >
            Are you sure you want to cancel this prescription?
            <br />
            This action cannot be undone, and the checkout link will expire.
          </Typography>
          <FormControlLabel
            control={
              <Checkbox
                checked={isUnderstood}
                onChange={(e) => setIsUnderstood(e.target.checked)}
                disabled={isLoading}
                sx={{
                  color: colors.primary.main,
                  "&.Mui-checked": {
                    color: colors.primary.main,
                  },
                }}
              />
            }
            label={
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: 500,
                  color: colors.text.primary,
                }}
              >
                I understand
              </Typography>
            }
          />
        </Box>
      }
      confirmText="Confirm"
      cancelText="Cancel"
      confirmColor={colors.primary.main}
      confirmHoverColor={colors.secondary.main}
      confirmTextHoverColor={colors.background.paper}
      loading={isLoading}
      disableConfirm={!isUnderstood}
      contentSx={{
        py: "24px",
        px: "16px",
      }}
    />
  );
};
